import { MenuItem, Stack } from '@mui/material';
import { useCashBalance } from '../../../../context/CashBalanceContext';
import { FormatCurrency } from '../../../../utils/numbers';
import Spinner from '../../../Spinner';
import {
  BoxMenu,
  BoxMenuItem,
  TypographyMenuItem,
  TypographyMenuItemAmount,
} from '../Layouts/StyledComponentsMenu';

export const WalletClosedDrawer = ({
  menuItem,
  handleClose,
  handleNavigateWallet,
  setActiveItem,
}) => {
  const { balance: balanceData, loading: loadingBalance, error: errorBalance } = useCashBalance();

  const walletAvailability = item => {
    if (item === 'Caja Disponible') {
      return balanceData?.balance ? FormatCurrency(balanceData?.balance) : '$0';
    }
    if (item === 'Dinero en Tránsito') {
      return balanceData?.transitAmount ? FormatCurrency(balanceData?.transitAmount) : '$0';
    }
  };

  if (loadingBalance) {
    return <Spinner />;
  }

  if (errorBalance) {
    throw new Error('Error component wallet drawer closed');
  }

  return (
    <BoxMenu sx={{ marginTop: '0px', padding: '0px' }}>
      {menuItem.subMenu
        .filter(
          subItem =>
            subItem.btnNameSub === 'Caja Disponible' || subItem.btnNameSub === 'Dinero en Tránsito',
        )
        .map(subItem => (
          <BoxMenuItem key={subItem.btnNameSub}>
            <MenuItem
              onClick={() => {
                handleNavigateWallet();
                setActiveItem(subItem.label);
                handleClose();
              }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Stack>
                <TypographyMenuItem marginLeft='0px'>{subItem.btnNameSub}</TypographyMenuItem>
                <TypographyMenuItemAmount>
                  {walletAvailability(subItem.btnNameSub)}
                </TypographyMenuItemAmount>
              </Stack>
            </MenuItem>
          </BoxMenuItem>
        ))}
    </BoxMenu>
  );
};
